import { configureStore, Action, getDefaultMiddleware } from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import logger from 'redux-logger';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { persistStore, persistReducer } from 'redux-persist';
import rootReducer, { RootState } from './rootReducer';

const persitConfig = {
  key: 'root',
  storage: AsyncStorage,
  blacklist: ['app'],
};

const persistedReducer = persistReducer<RootState>(persitConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [
    //    ...getDefaultMiddleware({immutableCheck: false, serializableCheck: false}).concat(logger),
    ...getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }), //.concat(logger),
  ],
});

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept(() => {
    const newRootReducer = require('./rootReducer').default;
    store.replaceReducer(persistReducer(persitConfig, newRootReducer));
  });
}

const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export default { store, persistor };
